export function resolveMcpAvailability(servers) {
  const all = Array.isArray(servers) ? servers : [];
  const selectable = all.filter((server) => server.is_active);
  const inactiveCount = all.length - selectable.length;

  if (inactiveCount === 0) {
    return { selectable, notice: '' };
  }

  const notice =
    inactiveCount === 1
      ? '1 servidor MCP desta conta está inativo e não aparece na lista. Ative em MCP para usar no roteamento.'
      : `${inactiveCount} servidores MCP desta conta estão inativos e não aparecem na lista. Ative em MCP para usar no roteamento.`;

  return { selectable, notice };
}
